/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Rep_BeyondInputs */

const en_us2_progress_extra_rep_beyond = /** @type {(inputs: Progress_Extra_Rep_BeyondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`21 or more`)
};

const pt_br2_progress_extra_rep_beyond = /** @type {(inputs: Progress_Extra_Rep_BeyondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`21 ou mais`)
};

const es_419_progress_extra_rep_beyond = /** @type {(inputs: Progress_Extra_Rep_BeyondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`21 o más`)
};

const pt_pt2_progress_extra_rep_beyond = /** @type {(inputs: Progress_Extra_Rep_BeyondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`21 ou mais`)
};

const fr_fr2_progress_extra_rep_beyond = /** @type {(inputs: Progress_Extra_Rep_BeyondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`21 ou plus`)
};

const de_de2_progress_extra_rep_beyond = /** @type {(inputs: Progress_Extra_Rep_BeyondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`21 oder mehr`)
};

const it_it2_progress_extra_rep_beyond = /** @type {(inputs: Progress_Extra_Rep_BeyondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`21 o più`)
};

/**
* | output |
* | --- |
* | "21 or more" |
*
* @param {Progress_Extra_Rep_BeyondInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_rep_beyond = /** @type {((inputs?: Progress_Extra_Rep_BeyondInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Rep_BeyondInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_rep_beyond(inputs)
	if (locale === "es-419") return es_419_progress_extra_rep_beyond(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_rep_beyond(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_rep_beyond(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_rep_beyond(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_rep_beyond(inputs)
	return en_us2_progress_extra_rep_beyond(inputs)
});
export { progress_extra_rep_beyond as "progress-extra.rep_beyond" }